import React from 'react'
import GradientBgLg from '../assets/images/gradient_bg_lg.jpg'

const FeaturesCta = ({ content = {} }) => {
  const {
    title = 'Turn Every Customer Voice Into Measurable Improvement',
    description = 'Stop losing complaints in chats. Stop ignoring commendations. Start managing feedback like a system.',
    buttonLabel = 'Talk to the team',
    buttonHref = '/contact',
    image = {
      src: '',
      alt: 'Feature highlight',
    },
  } = content

  return (
    <div>
      <section className="relative  pt-24 pb-20 px-6 lg:px-12">
        <div className="max-w-6xl mx-auto relative">

          {/* Top Visual */}
          <div
            data-aos="fade-down"
            className="relative z-10 mx-auto w-full max-w-4xl h-[220px] sm:h-[280px] lg:h-[340px] rounded-3xl shadow-lg overflow-hidden"
          >
            {image?.src ? (
              <img src={image.src} alt={image.alt || 'Feature highlight'} className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full bg-gray-200" />
            )}
          </div>
        </div>

        {/* Gradient CTA Container */}
        <div
          data-aos="fade-up"
          className="relative -mt-16 sm:-mt-20 bg-cover bg-center bg-no-repeat text-white rounded-[40px] px-6 sm:px-12 py-20 text-center shadow-2xl"
          style={{ backgroundImage: `url(${GradientBgLg})` }}
        >
          <div className="max-w-3xl mx-auto space-y-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mt-8 leading-tight">
              {title}
            </h2>

            <p className="text-purple-200 text-base sm:text-lg max-w-2xl mx-auto">
              {description}
            </p>

            <div className="pt-4">
              <a href={buttonHref} className="px-8 py-3 rounded-xl bg-white/20 backdrop-blur-md text-white font-medium shadow-md hover:bg-white/30 transition">
                {buttonLabel}
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default FeaturesCta
